/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  GetTransportsModelsBrandIdPathParams,
  GetTransportsModelsBrandIdQueryParams,
  GetTransportsModelsBrandId200,
  GetTransportsModelsBrandId400,
  GetTransportsModelsBrandIdQueryResponse,
} from '../entities/GetTransportsModelsBrandId'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { errorStructSchema } from './errorStructSchema'
import { v1GetTransportModelsResponseSchema } from './v1/getTransportModelsResponseSchema'
import { z } from 'zod'

export const getTransportsModelsBrandIdPathParamsSchema = z.object({
  brand_id: z.number().int().describe('Transport brand ID'),
}) as unknown as ToZod<GetTransportsModelsBrandIdPathParams>

export const getTransportsModelsBrandIdQueryParamsSchema = z
  .object({
    search: z.string().describe('Search').optional(),
  })
  .optional() as unknown as ToZod<GetTransportsModelsBrandIdQueryParams>

/**
 * @description OK
 */
export const getTransportsModelsBrandId200Schema = z.lazy(() => v1GetTransportModelsResponseSchema) as unknown as ToZod<GetTransportsModelsBrandId200>

/**
 * @description Bad Request
 */
export const getTransportsModelsBrandId400Schema = z.lazy(() => errorStructSchema) as unknown as ToZod<GetTransportsModelsBrandId400>

export const getTransportsModelsBrandIdQueryResponseSchema = z.lazy(
  () => getTransportsModelsBrandId200Schema,
) as unknown as ToZod<GetTransportsModelsBrandIdQueryResponse>